import React, {Component} from 'react'
import {Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Error from '../../pages/Error'
import {postCoursesFundingFilter, getCourseDetails, getSonePersonalDetails} from '../../../services/vu'
import {getCourseId, setCourseIdViaQueryParameter} from '../../../helpers/course'
import {courseStaticInfoCache, getAttributeCourseStaticInfo, hasSanctions} from '../../../helpers/enrolment'
import Loading from '../../pages/Loading'
import ResidencyType from '../../../enums/ResidencyType'
import {getConfiguration} from '../../../helpers/configuration'
import SanctionCard from '../SanctionCard'

const mapStateToProps = ({courses: {courseCode, data}}) => {
  return {
    courseCode: courseCode,
    course: data[courseCode]
  }
}

class PreEnrolChecker extends Component {
  constructor(props) {
    super(props)

    let defaultYear = sessionStorage.getItem("DEFAULT_YEAR");
    defaultYear = defaultYear === null ? "" : defaultYear

    this.state = {
      loaded: false,
      hasValidCourseId: false,
      isCourseStageOff: false,
      hasCourseAPIFailed: false,
      hasCourseorPersonalAPIFailed: false,
      course: null,
      personalDetails: null,
      containedDefautYear: this.props.location.pathname === "/manage/units/" + defaultYear
    }
  }

  setInitialState = (courseId, course, personalDetails) => {
      this.setIsEligibleForFinancial(course.potentialFundingType)
      this.setUsiStepApplicable(
        personalDetails.stuCitizenCd,
        course.isOffshoreFlag,
        course.courseSpkCatLvlCd
      )

      courseStaticInfoCache(course, courseId)

      this.stopLoading({
        course: course,
        personalDetails: personalDetails,
        hasValidCourseId: true,
        isCourseStageOff: course.courseStage === 'OFF',
        isCommencingRedirect: getAttributeCourseStaticInfo('isCommencing') === 'Y' && this.props.location.pathname.startsWith("/manage/units")
      })
  }

  componentDidMount() {

    const courseId = this.props.courseCode
    if (courseId) {
      let queryParams = {};
      queryParams['attemptNumber'] = this.props.course.attemptNumber;
      queryParams['versionNumber'] = this.props.course.versionNumber;
      queryParams["courseSSPNo"] = this.props.course.parentSSPNo
      queryParams['parentSSPNo'] = this.props.course.parentSSPNo;

      Promise.all([getCourseDetails(courseId, queryParams), getSonePersonalDetails()])
        .then(([course, personalDetails]) => {
          if (course && personalDetails) {
            let potentialFundingType = course.potentialFundingType;
            if (!potentialFundingType || !Array.isArray(potentialFundingType) || (Array.isArray(potentialFundingType) && potentialFundingType.length === 0)) {
              this.setInitialState(courseId, course, personalDetails)
            } else {
              postCoursesFundingFilter(course.potentialFundingType, course.liabilityCategoryCode, personalDetails.stuCitizenCd)
                .then(filteredFunding => {
                  course.potentialFundingType = filteredFunding;
                  this.setInitialState(courseId, course, personalDetails)
                })
            }
          } else {
            this.stopLoading()
          }
        })
        .catch(({ response: { status } }) => {
          if (status === 400) {
            this.stopLoading({
              hasValidCourseId: false
            })
          } else {
            this.stopLoading({
              hasCourseorPersonalAPIFailed: true
            })
          }
        })
    } else {
      this.stopLoading()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.isCommencingRedirect === true) {
      this.setState({
        isCommencingRedirect: false
      })
    } else if (prevState.containedDefautYear === true) {
      this.setState({
        containedDefautYear: false
      })
    }
  }

  stopLoading = (newState = {}) => {
    this.setState({
      loaded: true,
      ...newState
    })
  }

  setIsEligibleForFinancial = fundingTypeList => {
    if (fundingTypeList.length > 0) {
      sessionStorage.setItem('IS_ELIGIBLE_FOR_FINANCIAL', 'Y')
    } else {
      sessionStorage.setItem('IS_ELIGIBLE_FOR_FINANCIAL', 'N')
    }
  }

  setUsiStepApplicable = (citizenshipCode, offshoreFlag, graduationType) => {
    const isUsiApplicable =
      ResidencyType.Domestic.includes(citizenshipCode) ||
      (ResidencyType.International.includes(citizenshipCode) && !offshoreFlag)
    if (isUsiApplicable) {
      sessionStorage.setItem('ENROL_USI_ENABLED', 'Y')
    } else {
      sessionStorage.setItem('ENROL_USI_ENABLED', 'N')
    }
  }

  hasValidSSPNumber() {
    if (
      this.state.course.courseSSPNo === null ||
      this.state.course.courseSSPNo === 0
    ) {
      return false
    } else {
      return true
    }
  }

  hasValidCourseStage() {
    if (this.state.course.courseStage === 'ADM') {
      return true
    } else {
      return false
    }
  }

  canSelfManageCourse() {
    return this.state.course.isSelfManagedCourse
  }

  isCoursePostGradResearch() {
    if (this.state.course.courseStudyBasisCD === '$TIME') {
      return true
    } else {
      return false
    }
  }

  isVetCourse() {
    return this.state.course.isVet
  }

  isEnrolOpen() {
    return this.state.course.isEnrolOpen
  }

  isStudyPlanExpanded() {
    return this.state.course.isStudyPlanExpanded
  }

  isCommencing() {
    return this.state.course.isCommencing
  }

  getCourseIdProperty = queryParams => {
    return Object.keys(queryParams).find(
      queryParam => queryParam.toLocaleLowerCase() === 'courseid'
    )
  }

  getSelectedCourseId = () => {
    return setCourseIdViaQueryParameter(this.props.location.search)
  }

  render() {
    if (this.state.loaded) {
      if (this.state.isCourseStageOff) {
        return (
          <Switch>
            <Route
              render={() => (
                <Redirect
                  to={
                    getConfiguration('baseUrl') +
                    '/offer?courseId=' +
                    getCourseId()
                  }
                />
              )}
            />
          </Switch>
        )
      } else if (this.state.hasCourseorPersonalAPIFailed) {
        return (
          <Error
            title="ERROR"
            description={<p>System is down.</p>}
            longDescription={
              <span>
                For assistance, please contact{' '}
                <a href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres">
                  VUHQ
                </a>
                ‌.
              </span>
            }
          />
        )
      } else if (
        !this.state.hasValidCourseId ||
        !this.hasValidSSPNumber() ||
        !this.hasValidCourseStage()
      ) {
        return (
          <Error
            title="Invalid Course"
            description={
              <p>
                It looks like there is an issue with the course’s enrolment URL.
              </p>
            }
            longDescription={
              <span>
                If you're a commencing student, please wait for an email with
                the correct URL. If you're a continuing student, please navigate
                to <a href="https://myvu.edu.au">MyVU</a> and click on My Course
                from the dropdown menu, then Enrol Now on the My Course page.
              </span>
            }
          />
        )
      } else if (this.state.containedDefautYear) {
        return <Redirect to="/manage/units" replace={true} />
      } else if (
        (!this.canSelfManageCourse() && !this.props.location.pathname.startsWith("/manage/finance")) ||
        this.isCoursePostGradResearch() ||
        this.isVetCourse()
      ) {
        return (
          <Error
            title="We are unable to access your enrolment"
            description={<p>There is an error with your enrolment.</p>}
            longDescription={
              <span>
                For assistance, please contact{' '}
                <a href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres">
                  VUHQ
                </a>
                ‌.
              </span>
            }
            hideContactInfo="true"
          />
        )
      } else if (hasSanctions(this.state.personalDetails, getCourseId())) {
        return (
          <Error
            title="TRYING TO ENROL?"
            hideContactInfo={true}
            longDescription={<SanctionCard sanctions={this.state.personalDetails.studentSanctions} courseId={getCourseId()} />}
          />
        )
      } else if (this.state.isCommencingRedirect) {
        return <Redirect to={{pathname: getConfiguration('baseUrl') +"/"} } />
      } else {
        return this.props.children
      }
    } else {
      return <Loading />
    }
  }
}

export default withRouter(connect(mapStateToProps)(PreEnrolChecker))
